import React from "react";
import Spinner from "../../components/ui/Spinner";
import Select from "../../components/ui/Select";
import { useEligibleTranslationForReference } from "../../hooks/translation/useFetchTranslationReference";
import { getsylobProduct } from "../../utils/ApiUtils/TranslationHelper";

interface SelectTranslationProps {
  onChange: (selectedValue: number | undefined) => void;
  value: number | undefined;
  title?: string;
}

const SelectTranslation: React.FC<SelectTranslationProps> = ({ onChange, value, title }) => {
  const { data: translationDataExport, isLoading, isError } = useEligibleTranslationForReference();

  if (isLoading)
    return (
      <div className="flex items-center justify-center w-full">
        <Spinner />
      </div>
    );

  if (isError) return <p className="text-red-500">Error fetching available translations</p>;

  if (!translationDataExport || translationDataExport.length === 0)
    return <p className="text-lg font-display text-primary-dark">No available translations</p>;

  return (
    <div className="flex flex-col items-center gap-1">
      <h1 className="font-display p-1 text-sm">{title}</h1>
      <Select
        value={value}
        onChange={onChange}
        options={translationDataExport.map((translation) => ({
          label:
            (getsylobProduct(translation.product) || "") +
            " " +
            (translation.mavenVersion || "") +
            " [" +
            (translation.status || "") +
            "]",
          value: translation.id,
        }))}
        allowEmpty={true}
      />
    </div>
  );
};

export default SelectTranslation;
